import {ApiAction} from 'redux-upgrader';

export const GET_LOCALES = new ApiAction('GET_LOCALES');
export const GET_TIMEZONES = new ApiAction('GET_TIMEZONES');
